/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiSurfacePattern,
    ApiSurfacePatternFromJSON,
    ApiSurfacePatternToJSON,
    BopDisabledFlagMode,
    BopDisabledFlagModeFromJSON,
    BopDisabledFlagModeToJSON,
    BulkProductQrRequest,
    BulkProductQrRequestFromJSON,
    BulkProductQrRequestToJSON,
    ConfigBop,
    ConfigBopFromJSON,
    ConfigBopToJSON,
    ConfigurationFileUrls,
    ConfigurationFileUrlsFromJSON,
    ConfigurationFileUrlsToJSON,
    FacebookShareData,
    FacebookShareDataFromJSON,
    FacebookShareDataToJSON,
    ImageAndMaskResponse,
    ImageAndMaskResponseFromJSON,
    ImageAndMaskResponseToJSON,
    ItemMenuPath,
    ItemMenuPathFromJSON,
    ItemMenuPathToJSON,
    OutBop,
    OutBopFromJSON,
    OutBopToJSON,
    PreviewSurfaceLayoutsResponse,
    PreviewSurfaceLayoutsResponseFromJSON,
    PreviewSurfaceLayoutsResponseToJSON,
    ProductInfo,
    ProductInfoFromJSON,
    ProductInfoToJSON,
    RetailerEmailRequest,
    RetailerEmailRequestFromJSON,
    RetailerEmailRequestToJSON,
    SalespersonEmailRequest,
    SalespersonEmailRequestFromJSON,
    SalespersonEmailRequestToJSON,
    SdsAccountInfo,
    SdsAccountInfoFromJSON,
    SdsAccountInfoToJSON,
    SessionInitData,
    SessionInitDataFromJSON,
    SessionInitDataToJSON,
    SetSurfaceLayoutsResponse,
    SetSurfaceLayoutsResponseFromJSON,
    SetSurfaceLayoutsResponseToJSON,
    SetSurfacePatternResponse,
    SetSurfacePatternResponseFromJSON,
    SetSurfacePatternResponseToJSON,
    StringMap,
    StringMapFromJSON,
    StringMapToJSON,
    SurfaceLayoutGroup,
    SurfaceLayoutGroupFromJSON,
    SurfaceLayoutGroupToJSON,
    ValidateConfigResponse,
    ValidateConfigResponseFromJSON,
    ValidateConfigResponseToJSON,
} from '../models';

export interface ActivateMenuPostRequest {
    sessionId: string;
    menuId: string;
}

export interface ActivateProductsByArticleNoOnAllSurfacesPostRequest {
    sessionId: string;
    articleNo: string;
    activeMenu?: string;
    includeSummary?: boolean;
    onlyActivateFloorProductsOnFloors?: boolean;
    applyTo?: string;
}

export interface ActivateProductsByRetailerIdPostRequest {
    sessionId: string;
    articleNo: string;
    activeMenu?: string;
    includeSummary?: boolean;
    onlyActivateFloorProductsOnFloors?: boolean;
    applyTo?: string;
}

export interface ApiGetImageFromEncodedStringGetRequest {
    encodedConfig: string;
    encType?: string;
    market?: string;
    scaledWidth?: number;
    scaledHeight?: number;
    cropXRatio?: number;
    cropYRatio?: number;
    croppedWidth?: number;
    croppedHeight?: number;
    autoCrop?: boolean;
    autoCropMarginWidth?: number;
    autoCropMarginHeight?: number;
    shadows?: boolean;
    mainImage?: boolean;
    background?: boolean;
    useHd?: boolean;
    serie?: string;
    frame?: number;
    ext?: string;
    accountId?: string;
    allowUpscaling?: boolean;
    strict?: boolean;
}

export interface ApiGetProductTreeGetRequest {
    includeArticles?: boolean;
    accountId?: string;
    market?: string;
}

export interface ApiGetSummaryPdfGetRequest {
    encodedConfig: string;
    encType?: string;
    market?: string;
    accountId?: string;
    language?: string;
    hidePrice?: boolean;
    strict?: boolean;
}

export interface ChangeConfigItemPostRequest {
    sessionId: string;
    input: string;
    activeMenu?: string;
    includeSummary?: boolean;
}

export interface CreateSessionPostRequest {
    menuQuery?: string;
    lang?: string;
    market?: string;
    disabledFlagMode?: BopDisabledFlagMode;
    ttl?: number;
    origin?: string;
    category?: string;
    itemInterpreterOptions?: string;
}

export interface FindMenuPathsByArticleNoGetRequest {
    articleNo?: string;
    accountId?: string;
    onlyGetFloorProductsFromFloors?: boolean;
    models?: Array<string>;
    market?: string;
}

export interface GenerateProductQrBulkGridPostRequest {
    bulkProductQrRequest: BulkProductQrRequest;
}

export interface GenerateProductQrGetRequest {
    retailerId: string;
    size?: number;
}

export interface GetBlueprintLinkFromEncodedStringGetRequest {
    encodedConfig: string;
    encType?: string;
    market?: string;
    lang?: string;
    accountId?: string;
    strict?: boolean;
}

export interface GetConfigAsStringGetRequest {
    sessionId: string;
    encType: string;
}

export interface GetConfigImageAndMaskGetRequest {
    encodedConfig: string;
    encType?: string;
    market?: string;
    scaledWidth?: number;
    scaledHeight?: number;
    cropXRatio?: number;
    cropYRatio?: number;
    croppedWidth?: number;
    croppedHeight?: number;
    autoCrop?: boolean;
    autoCropMarginWidth?: number;
    autoCropMarginHeight?: number;
    shadows?: boolean;
    mainImage?: boolean;
    background?: boolean;
    useHd?: boolean;
    serie?: string;
    frame?: number;
    ext?: string;
    accountId?: string;
    allowUpscaling?: boolean;
    strict?: boolean;
}

export interface GetConfigImageVer2GetRequest {
    encodedConf: string;
    encType?: string;
    market?: string;
    scaleWidth?: number;
    scaleHeight?: number;
    cropXRatio?: number;
    cropYRatio?: number;
    croppedWidth?: number;
    croppedHeight?: number;
    skip?: string;
    skipGroups?: string;
    onlyUse?: string;
    serieName?: string;
    frame?: number;
    ext?: string;
    accountId?: string;
    allowUpscaling?: boolean;
    strict?: boolean;
}

export interface GetConfigurationFilesGetRequest {
    lang?: string;
    accountId?: string;
}

export interface GetCurrentConfigImageAndMaskGetRequest {
    sessionId: string;
    scaledWidth?: number;
    scaledHeight?: number;
    serieName?: string;
    frame?: number;
    cropXRatio?: number;
    cropYRatio?: number;
    croppedWidth?: number;
    croppedHeight?: number;
    skip?: string;
    skipGroups?: string;
    onlyUse?: string;
    onlyUseGroups?: string;
    fileType?: string;
    useHd?: boolean;
    autoCrop?: boolean;
    bgColorHex?: string;
    allowPadding?: boolean;
    allowUpscaling?: boolean;
}

export interface GetCurrentSdsAccountGetRequest {
    sessionId: string;
}

export interface GetFacebookShareDataGetRequest {
    sessionId: string;
}

export interface GetImageFromEncodedStringGetRequest {
    encodedConfig: string;
    encType?: string;
    market?: string;
    scaledWidth?: number;
    scaledHeight?: number;
    cropXRatio?: number;
    cropYRatio?: number;
    croppedWidth?: number;
    croppedHeight?: number;
    autoCrop?: boolean;
    autoCropMarginWidth?: number;
    autoCropMarginHeight?: number;
    shadows?: boolean;
    mainImage?: boolean;
    background?: boolean;
    useHd?: boolean;
    serie?: string;
    frame?: number;
    ext?: string;
    accountId?: string;
    allowUpscaling?: boolean;
    strict?: boolean;
}

export interface GetItemMetadataGetRequest {
    category: string;
    model: string;
    language: string;
    resourceKeys?: Array<string>;
    itemIds?: Array<string>;
    metaGrouping?: string;
    additionalKeys?: Array<string>;
}

export interface GetMediaKitGetRequest {
    sessionId: string;
}

export interface GetMenuPathsByRetailerIdGetRequest {
    articleNo?: string;
    accountId?: string;
    onlyGetFloorProductsFromFloors?: boolean;
    models?: Array<string>;
    market?: string;
}

export interface GetOrderSpecificationFromSummaryPostRequest {
    sessionId: string;
    retailerId?: string;
}

export interface GetOrderSpecificationV2PostRequest {
    sessionId: string;
    retailerId?: string;
}

export interface GetProductTreeGetRequest {
    includeArticles?: boolean;
    accountId?: string;
    market?: string;
}

export interface GetRootBopGetRequest {
    sessionId: string;
}

export interface GetSessionLanguageGetRequest {
    sessionId: string;
}

export interface GetSummaryPdfGetRequest {
    encodedConfig: string;
    encType?: string;
    market?: string;
    accountId?: string;
    language?: string;
    hidePrice?: boolean;
    strict?: boolean;
}

export interface GetSummaryPostRequest {
    sessionId: string;
}

export interface GetSurfaceLayoutsGetRequest {
    sessionId: string;
}

export interface LoadConfigFromStringPostRequest {
    sessionId: string;
    config: string;
    encType: string;
}

export interface PreviewSurfaceLayoutsPostRequest {
    sessionId: string;
    requestBody: { [key: string]: string; };
}

export interface ProductInfoGetRequest {
    language: string;
    market?: string;
    accountId?: string;
}

export interface RemoteControlQrGetRequest {
    sessionId: string;
    size?: number;
    lang?: string;
}

export interface SendCustomerMailPostRequest {
    sessionId: string;
    to: string;
    toDisplayName?: string;
    hidePrice?: boolean;
    siteUrl?: string;
    consents?: Array<string>;
}

export interface SendRetailerMailPostRequest {
    sessionId: string;
    retailerEmailRequest: RetailerEmailRequest;
}

export interface SendSalespersonMailPostRequest {
    sessionId: string;
    salespersonEmailRequest: SalespersonEmailRequest;
}

export interface SetCurrentSdsAccountPostRequest {
    sessionId: string;
    accountId: string;
}

export interface SetSurfaceLayoutsPostRequest {
    sessionId: string;
    requestBody: { [key: string]: string; };
    activeMenu?: string;
    includeSummary?: boolean;
}

export interface SetSurfacePatternPostRequest {
    sessionId: string;
    productId: string;
    pattern: ApiSurfacePattern;
}

export interface SimpleProductTreeGetRequest {
    includeArticles?: boolean;
    accountId?: string;
    market?: string;
}

export interface ValidateConfigGetRequest {
    encodedConfig: string;
    encType?: string;
    market?: string;
    accountId?: string;
}

/**
 * 
 */
export class SdsWebApi extends runtime.BaseAPI {

    /**
     * Activates a menu, returning its items and making subsequent  change config item calls return the items of that menu.
     */
    async activateMenuPostRaw(requestParameters: ActivateMenuPostRequest): Promise<runtime.ApiResponse<OutBop>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling activateMenuPost.');
        }

        if (requestParameters.menuId === null || requestParameters.menuId === undefined) {
            throw new runtime.RequiredError('menuId','Required parameter requestParameters.menuId was null or undefined when calling activateMenuPost.');
        }

        const queryParameters: any = {};

        if (requestParameters.sessionId !== undefined) {
            queryParameters['session_id'] = requestParameters.sessionId;
        }

        if (requestParameters.menuId !== undefined) {
            queryParameters['menu_id'] = requestParameters.menuId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/activate_menu`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OutBopFromJSON(jsonValue));
    }

    /**
     * Activates a menu, returning its items and making subsequent  change config item calls return the items of that menu.
     */
    async activateMenuPost(sessionId: string, menuId: string): Promise<OutBop> {
        const response = await this.activateMenuPostRaw({ sessionId: sessionId, menuId: menuId });
        return await response.value();
    }

    /**
     * Activates surface products with the specified article number (retailer ID)  on all surfaces where they can be found. This endpoint is used by the remote control  interface when product QR codes are scanned.
     */
    async activateProductsByArticleNoOnAllSurfacesPostRaw(requestParameters: ActivateProductsByArticleNoOnAllSurfacesPostRequest): Promise<runtime.ApiResponse<OutBop>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling activateProductsByArticleNoOnAllSurfacesPost.');
        }

        if (requestParameters.articleNo === null || requestParameters.articleNo === undefined) {
            throw new runtime.RequiredError('articleNo','Required parameter requestParameters.articleNo was null or undefined when calling activateProductsByArticleNoOnAllSurfacesPost.');
        }

        const queryParameters: any = {};

        if (requestParameters.sessionId !== undefined) {
            queryParameters['session_id'] = requestParameters.sessionId;
        }

        if (requestParameters.articleNo !== undefined) {
            queryParameters['article_no'] = requestParameters.articleNo;
        }

        if (requestParameters.activeMenu !== undefined) {
            queryParameters['active_menu'] = requestParameters.activeMenu;
        }

        if (requestParameters.includeSummary !== undefined) {
            queryParameters['include_summary'] = requestParameters.includeSummary;
        }

        if (requestParameters.onlyActivateFloorProductsOnFloors !== undefined) {
            queryParameters['only_activate_floor_products_on_floors'] = requestParameters.onlyActivateFloorProductsOnFloors;
        }

        if (requestParameters.applyTo !== undefined) {
            queryParameters['apply_to'] = requestParameters.applyTo;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/activate_products_by_article_no_on_all_surfaces`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OutBopFromJSON(jsonValue));
    }

    /**
     * Activates surface products with the specified article number (retailer ID)  on all surfaces where they can be found. This endpoint is used by the remote control  interface when product QR codes are scanned.
     */
    async activateProductsByArticleNoOnAllSurfacesPost(sessionId: string, articleNo: string, activeMenu?: string, includeSummary?: boolean, onlyActivateFloorProductsOnFloors?: boolean, applyTo?: string): Promise<OutBop> {
        const response = await this.activateProductsByArticleNoOnAllSurfacesPostRaw({ sessionId: sessionId, articleNo: articleNo, activeMenu: activeMenu, includeSummary: includeSummary, onlyActivateFloorProductsOnFloors: onlyActivateFloorProductsOnFloors, applyTo: applyTo });
        return await response.value();
    }

    /**
     * Activates surface products with the specified article number (retailer ID)  on all surfaces where they can be found. This endpoint is used by the remote control  interface when product QR codes are scanned.
     */
    async activateProductsByRetailerIdPostRaw(requestParameters: ActivateProductsByRetailerIdPostRequest): Promise<runtime.ApiResponse<OutBop>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling activateProductsByRetailerIdPost.');
        }

        if (requestParameters.articleNo === null || requestParameters.articleNo === undefined) {
            throw new runtime.RequiredError('articleNo','Required parameter requestParameters.articleNo was null or undefined when calling activateProductsByRetailerIdPost.');
        }

        const queryParameters: any = {};

        if (requestParameters.sessionId !== undefined) {
            queryParameters['session_id'] = requestParameters.sessionId;
        }

        if (requestParameters.articleNo !== undefined) {
            queryParameters['article_no'] = requestParameters.articleNo;
        }

        if (requestParameters.activeMenu !== undefined) {
            queryParameters['active_menu'] = requestParameters.activeMenu;
        }

        if (requestParameters.includeSummary !== undefined) {
            queryParameters['include_summary'] = requestParameters.includeSummary;
        }

        if (requestParameters.onlyActivateFloorProductsOnFloors !== undefined) {
            queryParameters['only_activate_floor_products_on_floors'] = requestParameters.onlyActivateFloorProductsOnFloors;
        }

        if (requestParameters.applyTo !== undefined) {
            queryParameters['apply_to'] = requestParameters.applyTo;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/activate_products_by_retailer_id`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OutBopFromJSON(jsonValue));
    }

    /**
     * Activates surface products with the specified article number (retailer ID)  on all surfaces where they can be found. This endpoint is used by the remote control  interface when product QR codes are scanned.
     */
    async activateProductsByRetailerIdPost(sessionId: string, articleNo: string, activeMenu?: string, includeSummary?: boolean, onlyActivateFloorProductsOnFloors?: boolean, applyTo?: string): Promise<OutBop> {
        const response = await this.activateProductsByRetailerIdPostRaw({ sessionId: sessionId, articleNo: articleNo, activeMenu: activeMenu, includeSummary: includeSummary, onlyActivateFloorProductsOnFloors: onlyActivateFloorProductsOnFloors, applyTo: applyTo });
        return await response.value();
    }

    /**
     * Stateless function for getting the image of a specific configuration  and returns the image directly in the response.
     */
    async apiGetImageFromEncodedStringGetRaw(requestParameters: ApiGetImageFromEncodedStringGetRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.encodedConfig === null || requestParameters.encodedConfig === undefined) {
            throw new runtime.RequiredError('encodedConfig','Required parameter requestParameters.encodedConfig was null or undefined when calling apiGetImageFromEncodedStringGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.encodedConfig !== undefined) {
            queryParameters['encoded_config'] = requestParameters.encodedConfig;
        }

        if (requestParameters.encType !== undefined) {
            queryParameters['enc_type'] = requestParameters.encType;
        }

        if (requestParameters.market !== undefined) {
            queryParameters['market'] = requestParameters.market;
        }

        if (requestParameters.scaledWidth !== undefined) {
            queryParameters['scaled_width'] = requestParameters.scaledWidth;
        }

        if (requestParameters.scaledHeight !== undefined) {
            queryParameters['scaled_height'] = requestParameters.scaledHeight;
        }

        if (requestParameters.cropXRatio !== undefined) {
            queryParameters['crop_x_ratio'] = requestParameters.cropXRatio;
        }

        if (requestParameters.cropYRatio !== undefined) {
            queryParameters['crop_y_ratio'] = requestParameters.cropYRatio;
        }

        if (requestParameters.croppedWidth !== undefined) {
            queryParameters['cropped_width'] = requestParameters.croppedWidth;
        }

        if (requestParameters.croppedHeight !== undefined) {
            queryParameters['cropped_height'] = requestParameters.croppedHeight;
        }

        if (requestParameters.autoCrop !== undefined) {
            queryParameters['auto_crop'] = requestParameters.autoCrop;
        }

        if (requestParameters.autoCropMarginWidth !== undefined) {
            queryParameters['auto_crop_margin_width'] = requestParameters.autoCropMarginWidth;
        }

        if (requestParameters.autoCropMarginHeight !== undefined) {
            queryParameters['auto_crop_margin_height'] = requestParameters.autoCropMarginHeight;
        }

        if (requestParameters.shadows !== undefined) {
            queryParameters['shadows'] = requestParameters.shadows;
        }

        if (requestParameters.mainImage !== undefined) {
            queryParameters['main_image'] = requestParameters.mainImage;
        }

        if (requestParameters.background !== undefined) {
            queryParameters['background'] = requestParameters.background;
        }

        if (requestParameters.useHd !== undefined) {
            queryParameters['use_hd'] = requestParameters.useHd;
        }

        if (requestParameters.serie !== undefined) {
            queryParameters['serie'] = requestParameters.serie;
        }

        if (requestParameters.frame !== undefined) {
            queryParameters['frame'] = requestParameters.frame;
        }

        if (requestParameters.ext !== undefined) {
            queryParameters['ext'] = requestParameters.ext;
        }

        if (requestParameters.accountId !== undefined) {
            queryParameters['account_id'] = requestParameters.accountId;
        }

        if (requestParameters.allowUpscaling !== undefined) {
            queryParameters['allow_upscaling'] = requestParameters.allowUpscaling;
        }

        if (requestParameters.strict !== undefined) {
            queryParameters['strict'] = requestParameters.strict;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/get_image_from_encoded_string`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Stateless function for getting the image of a specific configuration  and returns the image directly in the response.
     */
    async apiGetImageFromEncodedStringGet(encodedConfig: string, encType?: string, market?: string, scaledWidth?: number, scaledHeight?: number, cropXRatio?: number, cropYRatio?: number, croppedWidth?: number, croppedHeight?: number, autoCrop?: boolean, autoCropMarginWidth?: number, autoCropMarginHeight?: number, shadows?: boolean, mainImage?: boolean, background?: boolean, useHd?: boolean, serie?: string, frame?: number, ext?: string, accountId?: string, allowUpscaling?: boolean, strict?: boolean): Promise<void> {
        await this.apiGetImageFromEncodedStringGetRaw({ encodedConfig: encodedConfig, encType: encType, market: market, scaledWidth: scaledWidth, scaledHeight: scaledHeight, cropXRatio: cropXRatio, cropYRatio: cropYRatio, croppedWidth: croppedWidth, croppedHeight: croppedHeight, autoCrop: autoCrop, autoCropMarginWidth: autoCropMarginWidth, autoCropMarginHeight: autoCropMarginHeight, shadows: shadows, mainImage: mainImage, background: background, useHd: useHd, serie: serie, frame: frame, ext: ext, accountId: accountId, allowUpscaling: allowUpscaling, strict: strict });
    }

    /**
     * Gets the structure showing what can be requested  using the \"sds_encoder\" config encoding.
     */
    async apiGetProductTreeGetRaw(requestParameters: ApiGetProductTreeGetRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters.includeArticles !== undefined) {
            queryParameters['include_articles'] = requestParameters.includeArticles;
        }

        if (requestParameters.accountId !== undefined) {
            queryParameters['account_id'] = requestParameters.accountId;
        }

        if (requestParameters.market !== undefined) {
            queryParameters['market'] = requestParameters.market;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/get_product_tree`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Gets the structure showing what can be requested  using the \"sds_encoder\" config encoding.
     */
    async apiGetProductTreeGet(includeArticles?: boolean, accountId?: string, market?: string): Promise<string> {
        const response = await this.apiGetProductTreeGetRaw({ includeArticles: includeArticles, accountId: accountId, market: market });
        return await response.value();
    }

    /**
     * Generates a summary PDF on demand from a configuration string, without a session.  Mirrors M:SdsWeb.Controllers.SdsWebApiController.GetConfigImageAndMaskAsync(System.String,System.String,System.String,System.UInt32,System.UInt32,System.Single,System.Single,System.UInt32,System.UInt32,System.Boolean,System.UInt32,System.UInt32,System.Boolean,System.Boolean,System.Boolean,System.Boolean,System.String,System.Nullable{System.Int32},System.String,System.String,System.Boolean,System.Boolean): stateless, decodes the config and  resolves account/localization from query parameters.
     */
    async apiGetSummaryPdfGetRaw(requestParameters: ApiGetSummaryPdfGetRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.encodedConfig === null || requestParameters.encodedConfig === undefined) {
            throw new runtime.RequiredError('encodedConfig','Required parameter requestParameters.encodedConfig was null or undefined when calling apiGetSummaryPdfGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.encodedConfig !== undefined) {
            queryParameters['encoded_config'] = requestParameters.encodedConfig;
        }

        if (requestParameters.encType !== undefined) {
            queryParameters['enc_type'] = requestParameters.encType;
        }

        if (requestParameters.market !== undefined) {
            queryParameters['market'] = requestParameters.market;
        }

        if (requestParameters.accountId !== undefined) {
            queryParameters['account_id'] = requestParameters.accountId;
        }

        if (requestParameters.language !== undefined) {
            queryParameters['language'] = requestParameters.language;
        }

        if (requestParameters.hidePrice !== undefined) {
            queryParameters['hide_price'] = requestParameters.hidePrice;
        }

        if (requestParameters.strict !== undefined) {
            queryParameters['strict'] = requestParameters.strict;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/get_summary_pdf`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generates a summary PDF on demand from a configuration string, without a session.  Mirrors M:SdsWeb.Controllers.SdsWebApiController.GetConfigImageAndMaskAsync(System.String,System.String,System.String,System.UInt32,System.UInt32,System.Single,System.Single,System.UInt32,System.UInt32,System.Boolean,System.UInt32,System.UInt32,System.Boolean,System.Boolean,System.Boolean,System.Boolean,System.String,System.Nullable{System.Int32},System.String,System.String,System.Boolean,System.Boolean): stateless, decodes the config and  resolves account/localization from query parameters.
     */
    async apiGetSummaryPdfGet(encodedConfig: string, encType?: string, market?: string, accountId?: string, language?: string, hidePrice?: boolean, strict?: boolean): Promise<void> {
        await this.apiGetSummaryPdfGetRaw({ encodedConfig: encodedConfig, encType: encType, market: market, accountId: accountId, language: language, hidePrice: hidePrice, strict: strict });
    }

    /**
     * Changes an item in the configuration.
     */
    async changeConfigItemPostRaw(requestParameters: ChangeConfigItemPostRequest): Promise<runtime.ApiResponse<OutBop>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling changeConfigItemPost.');
        }

        if (requestParameters.input === null || requestParameters.input === undefined) {
            throw new runtime.RequiredError('input','Required parameter requestParameters.input was null or undefined when calling changeConfigItemPost.');
        }

        const queryParameters: any = {};

        if (requestParameters.sessionId !== undefined) {
            queryParameters['session_id'] = requestParameters.sessionId;
        }

        if (requestParameters.input !== undefined) {
            queryParameters['input'] = requestParameters.input;
        }

        if (requestParameters.activeMenu !== undefined) {
            queryParameters['active_menu'] = requestParameters.activeMenu;
        }

        if (requestParameters.includeSummary !== undefined) {
            queryParameters['include_summary'] = requestParameters.includeSummary;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/change_config_item`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OutBopFromJSON(jsonValue));
    }

    /**
     * Changes an item in the configuration.
     */
    async changeConfigItemPost(sessionId: string, input: string, activeMenu?: string, includeSummary?: boolean): Promise<OutBop> {
        const response = await this.changeConfigItemPostRaw({ sessionId: sessionId, input: input, activeMenu: activeMenu, includeSummary: includeSummary });
        return await response.value();
    }

    /**
     * Creates a new user session.
     */
    async createSessionPostRaw(requestParameters: CreateSessionPostRequest): Promise<runtime.ApiResponse<SessionInitData>> {
        const queryParameters: any = {};

        if (requestParameters.menuQuery !== undefined) {
            queryParameters['menu_query'] = requestParameters.menuQuery;
        }

        if (requestParameters.lang !== undefined) {
            queryParameters['lang'] = requestParameters.lang;
        }

        if (requestParameters.market !== undefined) {
            queryParameters['market'] = requestParameters.market;
        }

        if (requestParameters.disabledFlagMode !== undefined) {
            queryParameters['disabled_flag_mode'] = requestParameters.disabledFlagMode;
        }

        if (requestParameters.ttl !== undefined) {
            queryParameters['ttl'] = requestParameters.ttl;
        }

        if (requestParameters.origin !== undefined) {
            queryParameters['origin'] = requestParameters.origin;
        }

        if (requestParameters.category !== undefined) {
            queryParameters['category'] = requestParameters.category;
        }

        if (requestParameters.itemInterpreterOptions !== undefined) {
            queryParameters['item_interpreter_options'] = requestParameters.itemInterpreterOptions;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/create_session`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionInitDataFromJSON(jsonValue));
    }

    /**
     * Creates a new user session.
     */
    async createSessionPost(menuQuery?: string, lang?: string, market?: string, disabledFlagMode?: BopDisabledFlagMode, ttl?: number, origin?: string, category?: string, itemInterpreterOptions?: string): Promise<SessionInitData> {
        const response = await this.createSessionPostRaw({ menuQuery: menuQuery, lang: lang, market: market, disabledFlagMode: disabledFlagMode, ttl: ttl, origin: origin, category: category, itemInterpreterOptions: itemInterpreterOptions });
        return await response.value();
    }

    /**
     * Gets details about the current request including headers and query parameters.
     */
    async debugGetRequestInfoGetRaw(): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/debug/get_request_info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Gets details about the current request including headers and query parameters.
     */
    async debugGetRequestInfoGet(): Promise<{ [key: string]: any; }> {
        const response = await this.debugGetRequestInfoGetRaw();
        return await response.value();
    }

    /**
     */
    async embeddedHtmlGetRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/embedded.html`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async embeddedHtmlGet(): Promise<void> {
        await this.embeddedHtmlGetRaw();
    }

    /**
     * Searches multiple models for the products with the specified article number  and returns the menu paths to where they are found.
     */
    async findMenuPathsByArticleNoGetRaw(requestParameters: FindMenuPathsByArticleNoGetRequest): Promise<runtime.ApiResponse<Array<ItemMenuPath>>> {
        const queryParameters: any = {};

        if (requestParameters.articleNo !== undefined) {
            queryParameters['article_no'] = requestParameters.articleNo;
        }

        if (requestParameters.accountId !== undefined) {
            queryParameters['account_id'] = requestParameters.accountId;
        }

        if (requestParameters.onlyGetFloorProductsFromFloors !== undefined) {
            queryParameters['only_get_floor_products_from_floors'] = requestParameters.onlyGetFloorProductsFromFloors;
        }

        if (requestParameters.models) {
            queryParameters['models'] = requestParameters.models;
        }

        if (requestParameters.market !== undefined) {
            queryParameters['market'] = requestParameters.market;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/find_menu_paths_by_article_no`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ItemMenuPathFromJSON));
    }

    /**
     * Searches multiple models for the products with the specified article number  and returns the menu paths to where they are found.
     */
    async findMenuPathsByArticleNoGet(articleNo?: string, accountId?: string, onlyGetFloorProductsFromFloors?: boolean, models?: Array<string>, market?: string): Promise<Array<ItemMenuPath>> {
        const response = await this.findMenuPathsByArticleNoGetRaw({ articleNo: articleNo, accountId: accountId, onlyGetFloorProductsFromFloors: onlyGetFloorProductsFromFloors, models: models, market: market });
        return await response.value();
    }

    /**
     */
    async frontendSettingsJsonGetRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/frontend_settings.json`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async frontendSettingsJsonGet(): Promise<void> {
        await this.frontendSettingsJsonGetRaw();
    }

    /**
     * Generates a single SVG containing a grid of labeled QR codes — one per retailer ID,  suitable for printing as a sticker sheet. Same labeling treatment as the single-QR endpoint.
     */
    async generateProductQrBulkGridPostRaw(requestParameters: GenerateProductQrBulkGridPostRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.bulkProductQrRequest === null || requestParameters.bulkProductQrRequest === undefined) {
            throw new runtime.RequiredError('bulkProductQrRequest','Required parameter requestParameters.bulkProductQrRequest was null or undefined when calling generateProductQrBulkGridPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/generate_product_qr/bulk_grid`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkProductQrRequestToJSON(requestParameters.bulkProductQrRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generates a single SVG containing a grid of labeled QR codes — one per retailer ID,  suitable for printing as a sticker sheet. Same labeling treatment as the single-QR endpoint.
     */
    async generateProductQrBulkGridPost(bulkProductQrRequest: BulkProductQrRequest): Promise<void> {
        await this.generateProductQrBulkGridPostRaw({ bulkProductQrRequest: bulkProductQrRequest });
    }

    /**
     * Generates a QR code containing a retailer ID for printing and attaching to products.  Customers can use this endpoint to generate QR codes that can be scanned by the remote control interface  to activate products in a configurator session. The retailer ID is rendered as a printed label below  the QR (Spark Vision typography) so the printed code is identifiable without scanning it first.
     */
    async generateProductQrGetRaw(requestParameters: GenerateProductQrGetRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.retailerId === null || requestParameters.retailerId === undefined) {
            throw new runtime.RequiredError('retailerId','Required parameter requestParameters.retailerId was null or undefined when calling generateProductQrGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.retailerId !== undefined) {
            queryParameters['retailer_id'] = requestParameters.retailerId;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/generate_product_qr`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generates a QR code containing a retailer ID for printing and attaching to products.  Customers can use this endpoint to generate QR codes that can be scanned by the remote control interface  to activate products in a configurator session. The retailer ID is rendered as a printed label below  the QR (Spark Vision typography) so the printed code is identifiable without scanning it first.
     */
    async generateProductQrGet(retailerId: string, size?: number): Promise<void> {
        await this.generateProductQrGetRaw({ retailerId: retailerId, size: size });
    }

    /**
     * Stateless function for getting a blueprint link from an encoded string.
     */
    async getBlueprintLinkFromEncodedStringGetRaw(requestParameters: GetBlueprintLinkFromEncodedStringGetRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.encodedConfig === null || requestParameters.encodedConfig === undefined) {
            throw new runtime.RequiredError('encodedConfig','Required parameter requestParameters.encodedConfig was null or undefined when calling getBlueprintLinkFromEncodedStringGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.encodedConfig !== undefined) {
            queryParameters['encoded_config'] = requestParameters.encodedConfig;
        }

        if (requestParameters.encType !== undefined) {
            queryParameters['enc_type'] = requestParameters.encType;
        }

        if (requestParameters.market !== undefined) {
            queryParameters['market'] = requestParameters.market;
        }

        if (requestParameters.lang !== undefined) {
            queryParameters['lang'] = requestParameters.lang;
        }

        if (requestParameters.accountId !== undefined) {
            queryParameters['account_id'] = requestParameters.accountId;
        }

        if (requestParameters.strict !== undefined) {
            queryParameters['strict'] = requestParameters.strict;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/get_blueprint_link_from_encoded_string`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Stateless function for getting a blueprint link from an encoded string.
     */
    async getBlueprintLinkFromEncodedStringGet(encodedConfig: string, encType?: string, market?: string, lang?: string, accountId?: string, strict?: boolean): Promise<void> {
        await this.getBlueprintLinkFromEncodedStringGetRaw({ encodedConfig: encodedConfig, encType: encType, market: market, lang: lang, accountId: accountId, strict: strict });
    }

    /**
     * Gets backend settings also used by the frontend.
     */
    async getClientSettingsGetRaw(): Promise<runtime.ApiResponse<StringMap>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/get_client_settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => StringMapFromJSON(jsonValue));
    }

    /**
     * Gets backend settings also used by the frontend.
     */
    async getClientSettingsGet(): Promise<StringMap> {
        const response = await this.getClientSettingsGetRaw();
        return await response.value();
    }

    /**
     * Gets the active configuration for the session as a string with the specified encoding.  The session\'s `Language` resolves the Blueprint assortment id mapping  (see M:SdsWeb.Settings.SdsSettings.ResolveAssortmentIdMapping(ProtocolTypes.ProductLogic.Language)).
     */
    async getConfigAsStringGetRaw(requestParameters: GetConfigAsStringGetRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling getConfigAsStringGet.');
        }

        if (requestParameters.encType === null || requestParameters.encType === undefined) {
            throw new runtime.RequiredError('encType','Required parameter requestParameters.encType was null or undefined when calling getConfigAsStringGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.sessionId !== undefined) {
            queryParameters['session_id'] = requestParameters.sessionId;
        }

        if (requestParameters.encType !== undefined) {
            queryParameters['enc_type'] = requestParameters.encType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/get_config_as_string`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Gets the active configuration for the session as a string with the specified encoding.  The session\'s `Language` resolves the Blueprint assortment id mapping  (see M:SdsWeb.Settings.SdsSettings.ResolveAssortmentIdMapping(ProtocolTypes.ProductLogic.Language)).
     */
    async getConfigAsStringGet(sessionId: string, encType: string): Promise<string> {
        const response = await this.getConfigAsStringGetRaw({ sessionId: sessionId, encType: encType });
        return await response.value();
    }

    /**
     * Stateless function for getting the image of a specific configuration  and returns the image directly in the response.
     */
    async getConfigImageAndMaskGetRaw(requestParameters: GetConfigImageAndMaskGetRequest): Promise<runtime.ApiResponse<ImageAndMaskResponse>> {
        if (requestParameters.encodedConfig === null || requestParameters.encodedConfig === undefined) {
            throw new runtime.RequiredError('encodedConfig','Required parameter requestParameters.encodedConfig was null or undefined when calling getConfigImageAndMaskGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.encodedConfig !== undefined) {
            queryParameters['encoded_config'] = requestParameters.encodedConfig;
        }

        if (requestParameters.encType !== undefined) {
            queryParameters['enc_type'] = requestParameters.encType;
        }

        if (requestParameters.market !== undefined) {
            queryParameters['market'] = requestParameters.market;
        }

        if (requestParameters.scaledWidth !== undefined) {
            queryParameters['scaled_width'] = requestParameters.scaledWidth;
        }

        if (requestParameters.scaledHeight !== undefined) {
            queryParameters['scaled_height'] = requestParameters.scaledHeight;
        }

        if (requestParameters.cropXRatio !== undefined) {
            queryParameters['crop_x_ratio'] = requestParameters.cropXRatio;
        }

        if (requestParameters.cropYRatio !== undefined) {
            queryParameters['crop_y_ratio'] = requestParameters.cropYRatio;
        }

        if (requestParameters.croppedWidth !== undefined) {
            queryParameters['cropped_width'] = requestParameters.croppedWidth;
        }

        if (requestParameters.croppedHeight !== undefined) {
            queryParameters['cropped_height'] = requestParameters.croppedHeight;
        }

        if (requestParameters.autoCrop !== undefined) {
            queryParameters['auto_crop'] = requestParameters.autoCrop;
        }

        if (requestParameters.autoCropMarginWidth !== undefined) {
            queryParameters['auto_crop_margin_width'] = requestParameters.autoCropMarginWidth;
        }

        if (requestParameters.autoCropMarginHeight !== undefined) {
            queryParameters['auto_crop_margin_height'] = requestParameters.autoCropMarginHeight;
        }

        if (requestParameters.shadows !== undefined) {
            queryParameters['shadows'] = requestParameters.shadows;
        }

        if (requestParameters.mainImage !== undefined) {
            queryParameters['main_image'] = requestParameters.mainImage;
        }

        if (requestParameters.background !== undefined) {
            queryParameters['background'] = requestParameters.background;
        }

        if (requestParameters.useHd !== undefined) {
            queryParameters['use_hd'] = requestParameters.useHd;
        }

        if (requestParameters.serie !== undefined) {
            queryParameters['serie'] = requestParameters.serie;
        }

        if (requestParameters.frame !== undefined) {
            queryParameters['frame'] = requestParameters.frame;
        }

        if (requestParameters.ext !== undefined) {
            queryParameters['ext'] = requestParameters.ext;
        }

        if (requestParameters.accountId !== undefined) {
            queryParameters['account_id'] = requestParameters.accountId;
        }

        if (requestParameters.allowUpscaling !== undefined) {
            queryParameters['allow_upscaling'] = requestParameters.allowUpscaling;
        }

        if (requestParameters.strict !== undefined) {
            queryParameters['strict'] = requestParameters.strict;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/get_config_image_and_mask`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ImageAndMaskResponseFromJSON(jsonValue));
    }

    /**
     * Stateless function for getting the image of a specific configuration  and returns the image directly in the response.
     */
    async getConfigImageAndMaskGet(encodedConfig: string, encType?: string, market?: string, scaledWidth?: number, scaledHeight?: number, cropXRatio?: number, cropYRatio?: number, croppedWidth?: number, croppedHeight?: number, autoCrop?: boolean, autoCropMarginWidth?: number, autoCropMarginHeight?: number, shadows?: boolean, mainImage?: boolean, background?: boolean, useHd?: boolean, serie?: string, frame?: number, ext?: string, accountId?: string, allowUpscaling?: boolean, strict?: boolean): Promise<ImageAndMaskResponse> {
        const response = await this.getConfigImageAndMaskGetRaw({ encodedConfig: encodedConfig, encType: encType, market: market, scaledWidth: scaledWidth, scaledHeight: scaledHeight, cropXRatio: cropXRatio, cropYRatio: cropYRatio, croppedWidth: croppedWidth, croppedHeight: croppedHeight, autoCrop: autoCrop, autoCropMarginWidth: autoCropMarginWidth, autoCropMarginHeight: autoCropMarginHeight, shadows: shadows, mainImage: mainImage, background: background, useHd: useHd, serie: serie, frame: frame, ext: ext, accountId: accountId, allowUpscaling: allowUpscaling, strict: strict });
        return await response.value();
    }

    /**
     * Stateless function for generating an image of a specific configuration.
     */
    async getConfigImageVer2GetRaw(requestParameters: GetConfigImageVer2GetRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.encodedConf === null || requestParameters.encodedConf === undefined) {
            throw new runtime.RequiredError('encodedConf','Required parameter requestParameters.encodedConf was null or undefined when calling getConfigImageVer2Get.');
        }

        const queryParameters: any = {};

        if (requestParameters.encodedConf !== undefined) {
            queryParameters['encoded_conf'] = requestParameters.encodedConf;
        }

        if (requestParameters.encType !== undefined) {
            queryParameters['enc_type'] = requestParameters.encType;
        }

        if (requestParameters.market !== undefined) {
            queryParameters['market'] = requestParameters.market;
        }

        if (requestParameters.scaleWidth !== undefined) {
            queryParameters['scale_width'] = requestParameters.scaleWidth;
        }

        if (requestParameters.scaleHeight !== undefined) {
            queryParameters['scale_height'] = requestParameters.scaleHeight;
        }

        if (requestParameters.cropXRatio !== undefined) {
            queryParameters['crop_x_ratio'] = requestParameters.cropXRatio;
        }

        if (requestParameters.cropYRatio !== undefined) {
            queryParameters['crop_y_ratio'] = requestParameters.cropYRatio;
        }

        if (requestParameters.croppedWidth !== undefined) {
            queryParameters['cropped_width'] = requestParameters.croppedWidth;
        }

        if (requestParameters.croppedHeight !== undefined) {
            queryParameters['cropped_height'] = requestParameters.croppedHeight;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.skipGroups !== undefined) {
            queryParameters['skip_groups'] = requestParameters.skipGroups;
        }

        if (requestParameters.onlyUse !== undefined) {
            queryParameters['only_use'] = requestParameters.onlyUse;
        }

        if (requestParameters.serieName !== undefined) {
            queryParameters['serie_name'] = requestParameters.serieName;
        }

        if (requestParameters.frame !== undefined) {
            queryParameters['frame'] = requestParameters.frame;
        }

        if (requestParameters.ext !== undefined) {
            queryParameters['ext'] = requestParameters.ext;
        }

        if (requestParameters.accountId !== undefined) {
            queryParameters['account_id'] = requestParameters.accountId;
        }

        if (requestParameters.allowUpscaling !== undefined) {
            queryParameters['allow_upscaling'] = requestParameters.allowUpscaling;
        }

        if (requestParameters.strict !== undefined) {
            queryParameters['strict'] = requestParameters.strict;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/get_config_image_ver2`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Stateless function for generating an image of a specific configuration.
     */
    async getConfigImageVer2Get(encodedConf: string, encType?: string, market?: string, scaleWidth?: number, scaleHeight?: number, cropXRatio?: number, cropYRatio?: number, croppedWidth?: number, croppedHeight?: number, skip?: string, skipGroups?: string, onlyUse?: string, serieName?: string, frame?: number, ext?: string, accountId?: string, allowUpscaling?: boolean, strict?: boolean): Promise<string> {
        const response = await this.getConfigImageVer2GetRaw({ encodedConf: encodedConf, encType: encType, market: market, scaleWidth: scaleWidth, scaleHeight: scaleHeight, cropXRatio: cropXRatio, cropYRatio: cropYRatio, croppedWidth: croppedWidth, croppedHeight: croppedHeight, skip: skip, skipGroups: skipGroups, onlyUse: onlyUse, serieName: serieName, frame: frame, ext: ext, accountId: accountId, allowUpscaling: allowUpscaling, strict: strict });
        return await response.value();
    }

    /**
     * Returns the path of the files used to configure the frontend
     */
    async getConfigurationFilesGetRaw(requestParameters: GetConfigurationFilesGetRequest): Promise<runtime.ApiResponse<ConfigurationFileUrls>> {
        const queryParameters: any = {};

        if (requestParameters.lang !== undefined) {
            queryParameters['lang'] = requestParameters.lang;
        }

        if (requestParameters.accountId !== undefined) {
            queryParameters['account_id'] = requestParameters.accountId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/get_configuration_files`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigurationFileUrlsFromJSON(jsonValue));
    }

    /**
     * Returns the path of the files used to configure the frontend
     */
    async getConfigurationFilesGet(lang?: string, accountId?: string): Promise<ConfigurationFileUrls> {
        const response = await this.getConfigurationFilesGetRaw({ lang: lang, accountId: accountId });
        return await response.value();
    }

    /**
     * Generates an image and mask for the configuration of current session.
     */
    async getCurrentConfigImageAndMaskGetRaw(requestParameters: GetCurrentConfigImageAndMaskGetRequest): Promise<runtime.ApiResponse<ImageAndMaskResponse>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling getCurrentConfigImageAndMaskGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.sessionId !== undefined) {
            queryParameters['session_id'] = requestParameters.sessionId;
        }

        if (requestParameters.scaledWidth !== undefined) {
            queryParameters['scaled_width'] = requestParameters.scaledWidth;
        }

        if (requestParameters.scaledHeight !== undefined) {
            queryParameters['scaled_height'] = requestParameters.scaledHeight;
        }

        if (requestParameters.serieName !== undefined) {
            queryParameters['serie_name'] = requestParameters.serieName;
        }

        if (requestParameters.frame !== undefined) {
            queryParameters['frame'] = requestParameters.frame;
        }

        if (requestParameters.cropXRatio !== undefined) {
            queryParameters['crop_x_ratio'] = requestParameters.cropXRatio;
        }

        if (requestParameters.cropYRatio !== undefined) {
            queryParameters['crop_y_ratio'] = requestParameters.cropYRatio;
        }

        if (requestParameters.croppedWidth !== undefined) {
            queryParameters['cropped_width'] = requestParameters.croppedWidth;
        }

        if (requestParameters.croppedHeight !== undefined) {
            queryParameters['cropped_height'] = requestParameters.croppedHeight;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.skipGroups !== undefined) {
            queryParameters['skip_groups'] = requestParameters.skipGroups;
        }

        if (requestParameters.onlyUse !== undefined) {
            queryParameters['only_use'] = requestParameters.onlyUse;
        }

        if (requestParameters.onlyUseGroups !== undefined) {
            queryParameters['only_use_groups'] = requestParameters.onlyUseGroups;
        }

        if (requestParameters.fileType !== undefined) {
            queryParameters['file_type'] = requestParameters.fileType;
        }

        if (requestParameters.useHd !== undefined) {
            queryParameters['use_hd'] = requestParameters.useHd;
        }

        if (requestParameters.autoCrop !== undefined) {
            queryParameters['auto_crop'] = requestParameters.autoCrop;
        }

        if (requestParameters.bgColorHex !== undefined) {
            queryParameters['bg_color_hex'] = requestParameters.bgColorHex;
        }

        if (requestParameters.allowPadding !== undefined) {
            queryParameters['allow_padding'] = requestParameters.allowPadding;
        }

        if (requestParameters.allowUpscaling !== undefined) {
            queryParameters['allow_upscaling'] = requestParameters.allowUpscaling;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/get_current_config_image_and_mask`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ImageAndMaskResponseFromJSON(jsonValue));
    }

    /**
     * Generates an image and mask for the configuration of current session.
     */
    async getCurrentConfigImageAndMaskGet(sessionId: string, scaledWidth?: number, scaledHeight?: number, serieName?: string, frame?: number, cropXRatio?: number, cropYRatio?: number, croppedWidth?: number, croppedHeight?: number, skip?: string, skipGroups?: string, onlyUse?: string, onlyUseGroups?: string, fileType?: string, useHd?: boolean, autoCrop?: boolean, bgColorHex?: string, allowPadding?: boolean, allowUpscaling?: boolean): Promise<ImageAndMaskResponse> {
        const response = await this.getCurrentConfigImageAndMaskGetRaw({ sessionId: sessionId, scaledWidth: scaledWidth, scaledHeight: scaledHeight, serieName: serieName, frame: frame, cropXRatio: cropXRatio, cropYRatio: cropYRatio, croppedWidth: croppedWidth, croppedHeight: croppedHeight, skip: skip, skipGroups: skipGroups, onlyUse: onlyUse, onlyUseGroups: onlyUseGroups, fileType: fileType, useHd: useHd, autoCrop: autoCrop, bgColorHex: bgColorHex, allowPadding: allowPadding, allowUpscaling: allowUpscaling });
        return await response.value();
    }

    /**
     * Gets the DS Web Admin account used by current session, if any.
     */
    async getCurrentSdsAccountGetRaw(requestParameters: GetCurrentSdsAccountGetRequest): Promise<runtime.ApiResponse<SdsAccountInfo>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling getCurrentSdsAccountGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.sessionId !== undefined) {
            queryParameters['session_id'] = requestParameters.sessionId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/get_current_sds_account`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SdsAccountInfoFromJSON(jsonValue));
    }

    /**
     * Gets the DS Web Admin account used by current session, if any.
     */
    async getCurrentSdsAccountGet(sessionId: string): Promise<SdsAccountInfo> {
        const response = await this.getCurrentSdsAccountGetRaw({ sessionId: sessionId });
        return await response.value();
    }

    /**
     * Gets the default language of the application.
     */
    async getDefaultLanguageGetRaw(): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/get_default_language`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Gets the default language of the application.
     */
    async getDefaultLanguageGet(): Promise<string> {
        const response = await this.getDefaultLanguageGetRaw();
        return await response.value();
    }

    /**
     * Stateless call to get the default DS Web Admin account.
     */
    async getDefaultSdsAccountGetRaw(): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/get_default_sds_account`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Stateless call to get the default DS Web Admin account.
     */
    async getDefaultSdsAccountGet(): Promise<string> {
        const response = await this.getDefaultSdsAccountGetRaw();
        return await response.value();
    }

    /**
     */
    async getFacebookShareDataGetRaw(requestParameters: GetFacebookShareDataGetRequest): Promise<runtime.ApiResponse<FacebookShareData>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling getFacebookShareDataGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.sessionId !== undefined) {
            queryParameters['session_id'] = requestParameters.sessionId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/get_facebook_share_data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FacebookShareDataFromJSON(jsonValue));
    }

    /**
     */
    async getFacebookShareDataGet(sessionId: string): Promise<FacebookShareData> {
        const response = await this.getFacebookShareDataGetRaw({ sessionId: sessionId });
        return await response.value();
    }

    /**
     * Stateless function for getting the image of a specific configuration  and returns the image directly in the response.
     */
    async getImageFromEncodedStringGetRaw(requestParameters: GetImageFromEncodedStringGetRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.encodedConfig === null || requestParameters.encodedConfig === undefined) {
            throw new runtime.RequiredError('encodedConfig','Required parameter requestParameters.encodedConfig was null or undefined when calling getImageFromEncodedStringGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.encodedConfig !== undefined) {
            queryParameters['encoded_config'] = requestParameters.encodedConfig;
        }

        if (requestParameters.encType !== undefined) {
            queryParameters['enc_type'] = requestParameters.encType;
        }

        if (requestParameters.market !== undefined) {
            queryParameters['market'] = requestParameters.market;
        }

        if (requestParameters.scaledWidth !== undefined) {
            queryParameters['scaled_width'] = requestParameters.scaledWidth;
        }

        if (requestParameters.scaledHeight !== undefined) {
            queryParameters['scaled_height'] = requestParameters.scaledHeight;
        }

        if (requestParameters.cropXRatio !== undefined) {
            queryParameters['crop_x_ratio'] = requestParameters.cropXRatio;
        }

        if (requestParameters.cropYRatio !== undefined) {
            queryParameters['crop_y_ratio'] = requestParameters.cropYRatio;
        }

        if (requestParameters.croppedWidth !== undefined) {
            queryParameters['cropped_width'] = requestParameters.croppedWidth;
        }

        if (requestParameters.croppedHeight !== undefined) {
            queryParameters['cropped_height'] = requestParameters.croppedHeight;
        }

        if (requestParameters.autoCrop !== undefined) {
            queryParameters['auto_crop'] = requestParameters.autoCrop;
        }

        if (requestParameters.autoCropMarginWidth !== undefined) {
            queryParameters['auto_crop_margin_width'] = requestParameters.autoCropMarginWidth;
        }

        if (requestParameters.autoCropMarginHeight !== undefined) {
            queryParameters['auto_crop_margin_height'] = requestParameters.autoCropMarginHeight;
        }

        if (requestParameters.shadows !== undefined) {
            queryParameters['shadows'] = requestParameters.shadows;
        }

        if (requestParameters.mainImage !== undefined) {
            queryParameters['main_image'] = requestParameters.mainImage;
        }

        if (requestParameters.background !== undefined) {
            queryParameters['background'] = requestParameters.background;
        }

        if (requestParameters.useHd !== undefined) {
            queryParameters['use_hd'] = requestParameters.useHd;
        }

        if (requestParameters.serie !== undefined) {
            queryParameters['serie'] = requestParameters.serie;
        }

        if (requestParameters.frame !== undefined) {
            queryParameters['frame'] = requestParameters.frame;
        }

        if (requestParameters.ext !== undefined) {
            queryParameters['ext'] = requestParameters.ext;
        }

        if (requestParameters.accountId !== undefined) {
            queryParameters['account_id'] = requestParameters.accountId;
        }

        if (requestParameters.allowUpscaling !== undefined) {
            queryParameters['allow_upscaling'] = requestParameters.allowUpscaling;
        }

        if (requestParameters.strict !== undefined) {
            queryParameters['strict'] = requestParameters.strict;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/get_image_from_encoded_string`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Stateless function for getting the image of a specific configuration  and returns the image directly in the response.
     */
    async getImageFromEncodedStringGet(encodedConfig: string, encType?: string, market?: string, scaledWidth?: number, scaledHeight?: number, cropXRatio?: number, cropYRatio?: number, croppedWidth?: number, croppedHeight?: number, autoCrop?: boolean, autoCropMarginWidth?: number, autoCropMarginHeight?: number, shadows?: boolean, mainImage?: boolean, background?: boolean, useHd?: boolean, serie?: string, frame?: number, ext?: string, accountId?: string, allowUpscaling?: boolean, strict?: boolean): Promise<void> {
        await this.getImageFromEncodedStringGetRaw({ encodedConfig: encodedConfig, encType: encType, market: market, scaledWidth: scaledWidth, scaledHeight: scaledHeight, cropXRatio: cropXRatio, cropYRatio: cropYRatio, croppedWidth: croppedWidth, croppedHeight: croppedHeight, autoCrop: autoCrop, autoCropMarginWidth: autoCropMarginWidth, autoCropMarginHeight: autoCropMarginHeight, shadows: shadows, mainImage: mainImage, background: background, useHd: useHd, serie: serie, frame: frame, ext: ext, accountId: accountId, allowUpscaling: allowUpscaling, strict: strict });
    }

    /**
     * Generic function for getting metadata for items.
     */
    async getItemMetadataGetRaw(requestParameters: GetItemMetadataGetRequest): Promise<runtime.ApiResponse<{ [key: string]: { [key: string]: any; }; }>> {
        if (requestParameters.category === null || requestParameters.category === undefined) {
            throw new runtime.RequiredError('category','Required parameter requestParameters.category was null or undefined when calling getItemMetadataGet.');
        }

        if (requestParameters.model === null || requestParameters.model === undefined) {
            throw new runtime.RequiredError('model','Required parameter requestParameters.model was null or undefined when calling getItemMetadataGet.');
        }

        if (requestParameters.language === null || requestParameters.language === undefined) {
            throw new runtime.RequiredError('language','Required parameter requestParameters.language was null or undefined when calling getItemMetadataGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.category !== undefined) {
            queryParameters['category'] = requestParameters.category;
        }

        if (requestParameters.model !== undefined) {
            queryParameters['model'] = requestParameters.model;
        }

        if (requestParameters.language !== undefined) {
            queryParameters['language'] = requestParameters.language;
        }

        if (requestParameters.resourceKeys) {
            queryParameters['resource_keys'] = requestParameters.resourceKeys;
        }

        if (requestParameters.itemIds) {
            queryParameters['item_ids'] = requestParameters.itemIds;
        }

        if (requestParameters.metaGrouping !== undefined) {
            queryParameters['meta_grouping'] = requestParameters.metaGrouping;
        }

        if (requestParameters.additionalKeys) {
            queryParameters['additional_keys'] = requestParameters.additionalKeys;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/get_item_metadata`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Generic function for getting metadata for items.
     */
    async getItemMetadataGet(category: string, model: string, language: string, resourceKeys?: Array<string>, itemIds?: Array<string>, metaGrouping?: string, additionalKeys?: Array<string>): Promise<{ [key: string]: { [key: string]: any; }; }> {
        const response = await this.getItemMetadataGetRaw({ category: category, model: model, language: language, resourceKeys: resourceKeys, itemIds: itemIds, metaGrouping: metaGrouping, additionalKeys: additionalKeys });
        return await response.value();
    }

    /**
     * Generates zip file containing the background and main image as separate images.
     */
    async getMediaKitGetRaw(requestParameters: GetMediaKitGetRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling getMediaKitGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.sessionId !== undefined) {
            queryParameters['session_id'] = requestParameters.sessionId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/get_media_kit`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Generates zip file containing the background and main image as separate images.
     */
    async getMediaKitGet(sessionId: string): Promise<string> {
        const response = await this.getMediaKitGetRaw({ sessionId: sessionId });
        return await response.value();
    }

    /**
     * Searches multiple models for the products with the specified article number  and returns the menu paths to where they are found.
     */
    async getMenuPathsByRetailerIdGetRaw(requestParameters: GetMenuPathsByRetailerIdGetRequest): Promise<runtime.ApiResponse<Array<ItemMenuPath>>> {
        const queryParameters: any = {};

        if (requestParameters.articleNo !== undefined) {
            queryParameters['article_no'] = requestParameters.articleNo;
        }

        if (requestParameters.accountId !== undefined) {
            queryParameters['account_id'] = requestParameters.accountId;
        }

        if (requestParameters.onlyGetFloorProductsFromFloors !== undefined) {
            queryParameters['only_get_floor_products_from_floors'] = requestParameters.onlyGetFloorProductsFromFloors;
        }

        if (requestParameters.models) {
            queryParameters['models'] = requestParameters.models;
        }

        if (requestParameters.market !== undefined) {
            queryParameters['market'] = requestParameters.market;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/get_menu_paths_by_retailer_id`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ItemMenuPathFromJSON));
    }

    /**
     * Searches multiple models for the products with the specified article number  and returns the menu paths to where they are found.
     */
    async getMenuPathsByRetailerIdGet(articleNo?: string, accountId?: string, onlyGetFloorProductsFromFloors?: boolean, models?: Array<string>, market?: string): Promise<Array<ItemMenuPath>> {
        const response = await this.getMenuPathsByRetailerIdGetRaw({ articleNo: articleNo, accountId: accountId, onlyGetFloorProductsFromFloors: onlyGetFloorProductsFromFloors, models: models, market: market });
        return await response.value();
    }

    /**
     * Generates the specification of the current configuration in an XML file and returns its path.
     */
    async getOrderSpecificationFromSummaryPostRaw(requestParameters: GetOrderSpecificationFromSummaryPostRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling getOrderSpecificationFromSummaryPost.');
        }

        const queryParameters: any = {};

        if (requestParameters.sessionId !== undefined) {
            queryParameters['session_id'] = requestParameters.sessionId;
        }

        if (requestParameters.retailerId !== undefined) {
            queryParameters['retailer_id'] = requestParameters.retailerId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/get_order_specification_from_summary`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Generates the specification of the current configuration in an XML file and returns its path.
     */
    async getOrderSpecificationFromSummaryPost(sessionId: string, retailerId?: string): Promise<string> {
        const response = await this.getOrderSpecificationFromSummaryPostRaw({ sessionId: sessionId, retailerId: retailerId });
        return await response.value();
    }

    /**
     * Generates a list of the products in the current configuration to an XML file  which is saved on the server and returns its URL.
     */
    async getOrderSpecificationV2PostRaw(requestParameters: GetOrderSpecificationV2PostRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling getOrderSpecificationV2Post.');
        }

        const queryParameters: any = {};

        if (requestParameters.sessionId !== undefined) {
            queryParameters['session_id'] = requestParameters.sessionId;
        }

        if (requestParameters.retailerId !== undefined) {
            queryParameters['retailer_id'] = requestParameters.retailerId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/get_order_specification_v2`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Generates a list of the products in the current configuration to an XML file  which is saved on the server and returns its URL.
     */
    async getOrderSpecificationV2Post(sessionId: string, retailerId?: string): Promise<string> {
        const response = await this.getOrderSpecificationV2PostRaw({ sessionId: sessionId, retailerId: retailerId });
        return await response.value();
    }

    /**
     * Gets the structure showing what can be requested  using the \"sds_encoder\" config encoding.
     */
    async getProductTreeGetRaw(requestParameters: GetProductTreeGetRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters.includeArticles !== undefined) {
            queryParameters['include_articles'] = requestParameters.includeArticles;
        }

        if (requestParameters.accountId !== undefined) {
            queryParameters['account_id'] = requestParameters.accountId;
        }

        if (requestParameters.market !== undefined) {
            queryParameters['market'] = requestParameters.market;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/get_product_tree`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Gets the structure showing what can be requested  using the \"sds_encoder\" config encoding.
     */
    async getProductTreeGet(includeArticles?: boolean, accountId?: string, market?: string): Promise<string> {
        const response = await this.getProductTreeGetRaw({ includeArticles: includeArticles, accountId: accountId, market: market });
        return await response.value();
    }

    /**
     * Gets the bop for the root containing the main menus.
     */
    async getRootBopGetRaw(requestParameters: GetRootBopGetRequest): Promise<runtime.ApiResponse<OutBop>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling getRootBopGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.sessionId !== undefined) {
            queryParameters['session_id'] = requestParameters.sessionId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/get_root_bop`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OutBopFromJSON(jsonValue));
    }

    /**
     * Gets the bop for the root containing the main menus.
     */
    async getRootBopGet(sessionId: string): Promise<OutBop> {
        const response = await this.getRootBopGetRaw({ sessionId: sessionId });
        return await response.value();
    }

    /**
     * Gets the language in use by current session.
     */
    async getSessionLanguageGetRaw(requestParameters: GetSessionLanguageGetRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling getSessionLanguageGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.sessionId !== undefined) {
            queryParameters['session_id'] = requestParameters.sessionId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/get_session_language`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Gets the language in use by current session.
     */
    async getSessionLanguageGet(sessionId: string): Promise<string> {
        const response = await this.getSessionLanguageGetRaw({ sessionId: sessionId });
        return await response.value();
    }

    /**
     * Generates a summary PDF on demand from a configuration string, without a session.  Mirrors M:SdsWeb.Controllers.SdsWebApiController.GetConfigImageAndMaskAsync(System.String,System.String,System.String,System.UInt32,System.UInt32,System.Single,System.Single,System.UInt32,System.UInt32,System.Boolean,System.UInt32,System.UInt32,System.Boolean,System.Boolean,System.Boolean,System.Boolean,System.String,System.Nullable{System.Int32},System.String,System.String,System.Boolean,System.Boolean): stateless, decodes the config and  resolves account/localization from query parameters.
     */
    async getSummaryPdfGetRaw(requestParameters: GetSummaryPdfGetRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.encodedConfig === null || requestParameters.encodedConfig === undefined) {
            throw new runtime.RequiredError('encodedConfig','Required parameter requestParameters.encodedConfig was null or undefined when calling getSummaryPdfGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.encodedConfig !== undefined) {
            queryParameters['encoded_config'] = requestParameters.encodedConfig;
        }

        if (requestParameters.encType !== undefined) {
            queryParameters['enc_type'] = requestParameters.encType;
        }

        if (requestParameters.market !== undefined) {
            queryParameters['market'] = requestParameters.market;
        }

        if (requestParameters.accountId !== undefined) {
            queryParameters['account_id'] = requestParameters.accountId;
        }

        if (requestParameters.language !== undefined) {
            queryParameters['language'] = requestParameters.language;
        }

        if (requestParameters.hidePrice !== undefined) {
            queryParameters['hide_price'] = requestParameters.hidePrice;
        }

        if (requestParameters.strict !== undefined) {
            queryParameters['strict'] = requestParameters.strict;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/get_summary_pdf`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generates a summary PDF on demand from a configuration string, without a session.  Mirrors M:SdsWeb.Controllers.SdsWebApiController.GetConfigImageAndMaskAsync(System.String,System.String,System.String,System.UInt32,System.UInt32,System.Single,System.Single,System.UInt32,System.UInt32,System.Boolean,System.UInt32,System.UInt32,System.Boolean,System.Boolean,System.Boolean,System.Boolean,System.String,System.Nullable{System.Int32},System.String,System.String,System.Boolean,System.Boolean): stateless, decodes the config and  resolves account/localization from query parameters.
     */
    async getSummaryPdfGet(encodedConfig: string, encType?: string, market?: string, accountId?: string, language?: string, hidePrice?: boolean, strict?: boolean): Promise<void> {
        await this.getSummaryPdfGetRaw({ encodedConfig: encodedConfig, encType: encType, market: market, accountId: accountId, language: language, hidePrice: hidePrice, strict: strict });
    }

    /**
     * Generates a summary bop from the current configuration.
     */
    async getSummaryPostRaw(requestParameters: GetSummaryPostRequest): Promise<runtime.ApiResponse<OutBop>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling getSummaryPost.');
        }

        const queryParameters: any = {};

        if (requestParameters.sessionId !== undefined) {
            queryParameters['session_id'] = requestParameters.sessionId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/get_summary`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OutBopFromJSON(jsonValue));
    }

    /**
     * Generates a summary bop from the current configuration.
     */
    async getSummaryPost(sessionId: string): Promise<OutBop> {
        const response = await this.getSummaryPostRaw({ sessionId: sessionId });
        return await response.value();
    }

    /**
     * Gets the active and available surface layouts for the active model.
     */
    async getSurfaceLayoutsGetRaw(requestParameters: GetSurfaceLayoutsGetRequest): Promise<runtime.ApiResponse<Array<SurfaceLayoutGroup>>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling getSurfaceLayoutsGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.sessionId !== undefined) {
            queryParameters['session_id'] = requestParameters.sessionId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/get_surface_layouts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SurfaceLayoutGroupFromJSON));
    }

    /**
     * Gets the active and available surface layouts for the active model.
     */
    async getSurfaceLayoutsGet(sessionId: string): Promise<Array<SurfaceLayoutGroup>> {
        const response = await this.getSurfaceLayoutsGetRaw({ sessionId: sessionId });
        return await response.value();
    }

    /**
     * Replaced the configuration state for current session by  loading a serialized configuration from a string.
     */
    async loadConfigFromStringPostRaw(requestParameters: LoadConfigFromStringPostRequest): Promise<runtime.ApiResponse<ConfigBop>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling loadConfigFromStringPost.');
        }

        if (requestParameters.config === null || requestParameters.config === undefined) {
            throw new runtime.RequiredError('config','Required parameter requestParameters.config was null or undefined when calling loadConfigFromStringPost.');
        }

        if (requestParameters.encType === null || requestParameters.encType === undefined) {
            throw new runtime.RequiredError('encType','Required parameter requestParameters.encType was null or undefined when calling loadConfigFromStringPost.');
        }

        const queryParameters: any = {};

        if (requestParameters.sessionId !== undefined) {
            queryParameters['session_id'] = requestParameters.sessionId;
        }

        if (requestParameters.config !== undefined) {
            queryParameters['config'] = requestParameters.config;
        }

        if (requestParameters.encType !== undefined) {
            queryParameters['enc_type'] = requestParameters.encType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/load_config_from_string`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigBopFromJSON(jsonValue));
    }

    /**
     * Replaced the configuration state for current session by  loading a serialized configuration from a string.
     */
    async loadConfigFromStringPost(sessionId: string, config: string, encType: string): Promise<ConfigBop> {
        const response = await this.loadConfigFromStringPostRaw({ sessionId: sessionId, config: config, encType: encType });
        return await response.value();
    }

    /**
     * Takes a config string, changes one or more surface layouts and returns a new config string.
     */
    async previewSurfaceLayoutsPostRaw(requestParameters: PreviewSurfaceLayoutsPostRequest): Promise<runtime.ApiResponse<PreviewSurfaceLayoutsResponse>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling previewSurfaceLayoutsPost.');
        }

        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling previewSurfaceLayoutsPost.');
        }

        const queryParameters: any = {};

        if (requestParameters.sessionId !== undefined) {
            queryParameters['session_id'] = requestParameters.sessionId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/preview_surface_layouts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PreviewSurfaceLayoutsResponseFromJSON(jsonValue));
    }

    /**
     * Takes a config string, changes one or more surface layouts and returns a new config string.
     */
    async previewSurfaceLayoutsPost(sessionId: string, requestBody: { [key: string]: string; }): Promise<PreviewSurfaceLayoutsResponse> {
        const response = await this.previewSurfaceLayoutsPostRaw({ sessionId: sessionId, requestBody: requestBody });
        return await response.value();
    }

    /**
     * Gets product info that is shared for products between the different rooms and surfaces.
     */
    async productInfoGetRaw(requestParameters: ProductInfoGetRequest): Promise<runtime.ApiResponse<Array<ProductInfo>>> {
        if (requestParameters.language === null || requestParameters.language === undefined) {
            throw new runtime.RequiredError('language','Required parameter requestParameters.language was null or undefined when calling productInfoGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.language !== undefined) {
            queryParameters['language'] = requestParameters.language;
        }

        if (requestParameters.market !== undefined) {
            queryParameters['market'] = requestParameters.market;
        }

        if (requestParameters.accountId !== undefined) {
            queryParameters['account_id'] = requestParameters.accountId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/product_info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProductInfoFromJSON));
    }

    /**
     * Gets product info that is shared for products between the different rooms and surfaces.
     */
    async productInfoGet(language: string, market?: string, accountId?: string): Promise<Array<ProductInfo>> {
        const response = await this.productInfoGetRaw({ language: language, market: market, accountId: accountId });
        return await response.value();
    }

    /**
     * Mobile remote control page for connecting to a session and scanning product QR codes.  Both `session_id` and the optional translations blob (`t`) arrive via the  query string (encoded into the connection QR by  M:SdsWeb.Services.RemoteControlService.BuildRemoteControlUrl(System.String,System.String,System.String)) and are read by the page\'s  JavaScript directly from `window.location.search` — the controller never  inspects them. The page is served unconditionally and falls back to its embedded  English strings when `t` is absent or unparseable.
     */
    async remoteControlGetRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/remote_control`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mobile remote control page for connecting to a session and scanning product QR codes.  Both `session_id` and the optional translations blob (`t`) arrive via the  query string (encoded into the connection QR by  M:SdsWeb.Services.RemoteControlService.BuildRemoteControlUrl(System.String,System.String,System.String)) and are read by the page\'s  JavaScript directly from `window.location.search` — the controller never  inspects them. The page is served unconditionally and falls back to its embedded  English strings when `t` is absent or unparseable.
     */
    async remoteControlGet(): Promise<void> {
        await this.remoteControlGetRaw();
    }

    /**
     * Generates a QR code for remote control connection to the session.  This QR code can be scanned by a mobile device to open the remote control interface  that allows scanning product QR codes to activate them in the configurator session.
     */
    async remoteControlQrGetRaw(requestParameters: RemoteControlQrGetRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling remoteControlQrGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.sessionId !== undefined) {
            queryParameters['session_id'] = requestParameters.sessionId;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.lang !== undefined) {
            queryParameters['lang'] = requestParameters.lang;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/remote_control/qr`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generates a QR code for remote control connection to the session.  This QR code can be scanned by a mobile device to open the remote control interface  that allows scanning product QR codes to activate them in the configurator session.
     */
    async remoteControlQrGet(sessionId: string, size?: number, lang?: string): Promise<void> {
        await this.remoteControlQrGetRaw({ sessionId: sessionId, size: size, lang: lang });
    }

    /**
     * Sends a summary email to the user.
     */
    async sendCustomerMailPostRaw(requestParameters: SendCustomerMailPostRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling sendCustomerMailPost.');
        }

        if (requestParameters.to === null || requestParameters.to === undefined) {
            throw new runtime.RequiredError('to','Required parameter requestParameters.to was null or undefined when calling sendCustomerMailPost.');
        }

        const queryParameters: any = {};

        if (requestParameters.sessionId !== undefined) {
            queryParameters['session_id'] = requestParameters.sessionId;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        if (requestParameters.toDisplayName !== undefined) {
            queryParameters['to_display_name'] = requestParameters.toDisplayName;
        }

        if (requestParameters.hidePrice !== undefined) {
            queryParameters['hide_price'] = requestParameters.hidePrice;
        }

        if (requestParameters.siteUrl !== undefined) {
            queryParameters['site_url'] = requestParameters.siteUrl;
        }

        if (requestParameters.consents) {
            queryParameters['consents'] = requestParameters.consents;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/send_customer_mail`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Sends a summary email to the user.
     */
    async sendCustomerMailPost(sessionId: string, to: string, toDisplayName?: string, hidePrice?: boolean, siteUrl?: string, consents?: Array<string>): Promise<void> {
        await this.sendCustomerMailPostRaw({ sessionId: sessionId, to: to, toDisplayName: toDisplayName, hidePrice: hidePrice, siteUrl: siteUrl, consents: consents });
    }

    /**
     * Sends a summary email to the user.
     */
    async sendRetailerMailPostRaw(requestParameters: SendRetailerMailPostRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling sendRetailerMailPost.');
        }

        if (requestParameters.retailerEmailRequest === null || requestParameters.retailerEmailRequest === undefined) {
            throw new runtime.RequiredError('retailerEmailRequest','Required parameter requestParameters.retailerEmailRequest was null or undefined when calling sendRetailerMailPost.');
        }

        const queryParameters: any = {};

        if (requestParameters.sessionId !== undefined) {
            queryParameters['session_id'] = requestParameters.sessionId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/send_retailer_mail`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RetailerEmailRequestToJSON(requestParameters.retailerEmailRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Sends a summary email to the user.
     */
    async sendRetailerMailPost(sessionId: string, retailerEmailRequest: RetailerEmailRequest): Promise<void> {
        await this.sendRetailerMailPostRaw({ sessionId: sessionId, retailerEmailRequest: retailerEmailRequest });
    }

    /**
     * Emails the current configuration summary, as a PDF, to a salesperson chosen from the account\'s  configured list — the in-store \"Send in Shop\" card. The chosen address must be present and  enabled in that list, otherwise nothing is sent.
     */
    async sendSalespersonMailPostRaw(requestParameters: SendSalespersonMailPostRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling sendSalespersonMailPost.');
        }

        if (requestParameters.salespersonEmailRequest === null || requestParameters.salespersonEmailRequest === undefined) {
            throw new runtime.RequiredError('salespersonEmailRequest','Required parameter requestParameters.salespersonEmailRequest was null or undefined when calling sendSalespersonMailPost.');
        }

        const queryParameters: any = {};

        if (requestParameters.sessionId !== undefined) {
            queryParameters['session_id'] = requestParameters.sessionId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/send_salesperson_mail`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SalespersonEmailRequestToJSON(requestParameters.salespersonEmailRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Emails the current configuration summary, as a PDF, to a salesperson chosen from the account\'s  configured list — the in-store \"Send in Shop\" card. The chosen address must be present and  enabled in that list, otherwise nothing is sent.
     */
    async sendSalespersonMailPost(sessionId: string, salespersonEmailRequest: SalespersonEmailRequest): Promise<void> {
        await this.sendSalespersonMailPostRaw({ sessionId: sessionId, salespersonEmailRequest: salespersonEmailRequest });
    }

    /**
     * Sets the current SDS account (DS Web Admin account).
     */
    async setCurrentSdsAccountPostRaw(requestParameters: SetCurrentSdsAccountPostRequest): Promise<runtime.ApiResponse<SdsAccountInfo>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling setCurrentSdsAccountPost.');
        }

        if (requestParameters.accountId === null || requestParameters.accountId === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling setCurrentSdsAccountPost.');
        }

        const queryParameters: any = {};

        if (requestParameters.sessionId !== undefined) {
            queryParameters['session_id'] = requestParameters.sessionId;
        }

        if (requestParameters.accountId !== undefined) {
            queryParameters['account_id'] = requestParameters.accountId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/set_current_sds_account`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SdsAccountInfoFromJSON(jsonValue));
    }

    /**
     * Sets the current SDS account (DS Web Admin account).
     */
    async setCurrentSdsAccountPost(sessionId: string, accountId: string): Promise<SdsAccountInfo> {
        const response = await this.setCurrentSdsAccountPostRaw({ sessionId: sessionId, accountId: accountId });
        return await response.value();
    }

    /**
     * Sets the active layout for multiple surfaces.
     */
    async setSurfaceLayoutsPostRaw(requestParameters: SetSurfaceLayoutsPostRequest): Promise<runtime.ApiResponse<SetSurfaceLayoutsResponse>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling setSurfaceLayoutsPost.');
        }

        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling setSurfaceLayoutsPost.');
        }

        const queryParameters: any = {};

        if (requestParameters.sessionId !== undefined) {
            queryParameters['session_id'] = requestParameters.sessionId;
        }

        if (requestParameters.activeMenu !== undefined) {
            queryParameters['active_menu'] = requestParameters.activeMenu;
        }

        if (requestParameters.includeSummary !== undefined) {
            queryParameters['include_summary'] = requestParameters.includeSummary;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/set_surface_layouts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SetSurfaceLayoutsResponseFromJSON(jsonValue));
    }

    /**
     * Sets the active layout for multiple surfaces.
     */
    async setSurfaceLayoutsPost(sessionId: string, requestBody: { [key: string]: string; }, activeMenu?: string, includeSummary?: boolean): Promise<SetSurfaceLayoutsResponse> {
        const response = await this.setSurfaceLayoutsPostRaw({ sessionId: sessionId, requestBody: requestBody, activeMenu: activeMenu, includeSummary: includeSummary });
        return await response.value();
    }

    /**
     * Sets the pattern for an active surface.
     */
    async setSurfacePatternPostRaw(requestParameters: SetSurfacePatternPostRequest): Promise<runtime.ApiResponse<SetSurfacePatternResponse>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling setSurfacePatternPost.');
        }

        if (requestParameters.productId === null || requestParameters.productId === undefined) {
            throw new runtime.RequiredError('productId','Required parameter requestParameters.productId was null or undefined when calling setSurfacePatternPost.');
        }

        if (requestParameters.pattern === null || requestParameters.pattern === undefined) {
            throw new runtime.RequiredError('pattern','Required parameter requestParameters.pattern was null or undefined when calling setSurfacePatternPost.');
        }

        const queryParameters: any = {};

        if (requestParameters.sessionId !== undefined) {
            queryParameters['session_id'] = requestParameters.sessionId;
        }

        if (requestParameters.productId !== undefined) {
            queryParameters['product_id'] = requestParameters.productId;
        }

        if (requestParameters.pattern !== undefined) {
            queryParameters['pattern'] = requestParameters.pattern;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/set_surface_pattern`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SetSurfacePatternResponseFromJSON(jsonValue));
    }

    /**
     * Sets the pattern for an active surface.
     */
    async setSurfacePatternPost(sessionId: string, productId: string, pattern: ApiSurfacePattern): Promise<SetSurfacePatternResponse> {
        const response = await this.setSurfacePatternPostRaw({ sessionId: sessionId, productId: productId, pattern: pattern });
        return await response.value();
    }

    /**
     * Gets the structure showing what can be requested  using the \"simple\" config encoding.
     */
    async simpleProductTreeGetRaw(requestParameters: SimpleProductTreeGetRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters.includeArticles !== undefined) {
            queryParameters['include_articles'] = requestParameters.includeArticles;
        }

        if (requestParameters.accountId !== undefined) {
            queryParameters['account_id'] = requestParameters.accountId;
        }

        if (requestParameters.market !== undefined) {
            queryParameters['market'] = requestParameters.market;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/simple_product_tree`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Gets the structure showing what can be requested  using the \"simple\" config encoding.
     */
    async simpleProductTreeGet(includeArticles?: boolean, accountId?: string, market?: string): Promise<string> {
        const response = await this.simpleProductTreeGetRaw({ includeArticles: includeArticles, accountId: accountId, market: market });
        return await response.value();
    }

    /**
     */
    async validateConfigGetRaw(requestParameters: ValidateConfigGetRequest): Promise<runtime.ApiResponse<ValidateConfigResponse>> {
        if (requestParameters.encodedConfig === null || requestParameters.encodedConfig === undefined) {
            throw new runtime.RequiredError('encodedConfig','Required parameter requestParameters.encodedConfig was null or undefined when calling validateConfigGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.encodedConfig !== undefined) {
            queryParameters['encoded_config'] = requestParameters.encodedConfig;
        }

        if (requestParameters.encType !== undefined) {
            queryParameters['enc_type'] = requestParameters.encType;
        }

        if (requestParameters.market !== undefined) {
            queryParameters['market'] = requestParameters.market;
        }

        if (requestParameters.accountId !== undefined) {
            queryParameters['account_id'] = requestParameters.accountId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/validate_config`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidateConfigResponseFromJSON(jsonValue));
    }

    /**
     */
    async validateConfigGet(encodedConfig: string, encType?: string, market?: string, accountId?: string): Promise<ValidateConfigResponse> {
        const response = await this.validateConfigGetRaw({ encodedConfig: encodedConfig, encType: encType, market: market, accountId: accountId });
        return await response.value();
    }

}
